"use client"
import { useState, useEffect } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Clock } from 'lucide-react';

export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const targetDate = new Date('2025-10-14T00:00:00').getTime();

    const updateCountdown = () => {
      const now = new Date().getTime();
      const difference = targetDate - now;

      if (difference > 0) {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        setTimeLeft({ days, hours, minutes, seconds });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Card className="bg-white dark:bg-gray-800 p-6 shadow-lg border border-gray-200 dark:border-gray-700">
      <CardContent className="p-0">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
          <Clock className="w-5 h-5 text-accent-orange mr-2" />
          Time Until Windows 10 Support Ends
        </h3>
        <div className="grid grid-cols-4 gap-4 text-center">
          <div>
            <div className="text-2xl font-bold text-dell-blue">{timeLeft.days}</div>
            <div className="text-sm text-gray-600 dark:text-gray-400">Days</div>
          </div>
          <div>
            <div className="text-2xl font-bold text-dell-blue">{timeLeft.hours}</div>
            <div className="text-sm text-gray-600 dark:text-gray-400">Hours</div>
          </div>
          <div>
            <div className="text-2xl font-bold text-dell-blue">{timeLeft.minutes}</div>
            <div className="text-sm text-gray-600 dark:text-gray-400">Minutes</div>
          </div>
          <div>
            <div className="text-2xl font-bold text-dell-blue">{timeLeft.seconds}</div>
            <div className="text-sm text-gray-600 dark:text-gray-400">Seconds</div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
